'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Panel, PanelContent } from '@/components/ui/panel';
interface MarketBoostersErrorProps {
  onRetry: () => void;
}
export function MarketBoostersError(t0) {
  const $ = _c(12);
  const {
    onRetry
  } = t0;
  const t = useTranslations("market.boosters");
  let t1;
  if ($[0] !== t) {
    t1 = t("error_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h3 className="text-heading-sm text-foreground-primary">{t1}</h3>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("error_retry");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onRetry || $[7] !== t3) {
    t4 = <AnimatedButton variant="secondary" onClick={onRetry}>{t3}</AnimatedButton>;
    $[6] = onRetry;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <Panel data-testid="market-boosters-error"><PanelContent className="flex flex-col items-center gap-4 py-12">{t2}{t4}</PanelContent></Panel>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}